//disable IE ajax request caching
import {IHttpProvider} from "angular";

export default function disableCache($httpProvider: IHttpProvider) {
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Thu, 01 Jan 1970 00:00:00 GMT';
}

disableCache.$inject = ['$httpProvider'];
